module.exports = __webpack_public_path__ + "static/media/handshake.a4c2b10e.jpg";